import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetServiceBySlugQuery } from "../../../redux/api/ServicesApi/servicesApi";
import ServiceComponent from "../../../Components/ServiceComponent";
import LoaderSpinner from "../../../Components/LoaderSpinner";
import SEO from "../../../Components/SEO";

const ServiceDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const { data: service, isLoading, error } = useGetServiceBySlugQuery(slug);

  useEffect(() => {
    if (error && error.status === 404) {
      navigate("/404");
    }
  }, [error, navigate]);

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "60vh" }}
      >
        <LoaderSpinner />
      </div>
    );
  }

  if (!service) {
    return null;
  }

  return (
    <>
      <SEO
        title={
          service.meta_title ||
          `${service.service_title} - Ideal Corporate Services`
        }
        description={service.meta_description}
        keywords={service.meta_keyword}
      />
      <ServiceComponent data={service} />
    </>
  );
};

export default ServiceDetail;
